import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Step } from '@classes/step/step';
import { Role, StepUpdate, UserPlatform, UserUpdate } from '@classes/user/user-platform';
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import { AuthService } from '@services/auth/auth.service';
import { CryptoPasswordService } from '@services/crypto-password/crypto-password.service';
import { DataService } from '@services/data/data.service';
import { RoleService } from '@services/role/role.service';
import { StepsService } from '@services/step/steps.service';
import { UsersService } from '@services/users/users.service';

const reader = new FileReader();

export interface DialogData {
  user: UserPlatform;
}

@Component({
  selector: 'app-user-update',
  templateUrl: './user-update.component.html',
  styleUrls: ['./user-update.component.scss']
})
export class UserUpdateComponent implements OnInit {
  faCamera = faCamera;

  updateUserForm: FormGroup;
  inactive = true;
  confirmUpdateUser = false;
  roles: Role[];
  valueForm: string[] = [];
  user: UserPlatform;
  usertest: string;

  isActive: boolean;
  isActiveValue: boolean;
  color: ThemePalette = 'primary';
  steps: any[];
  stepsForUser: StepUpdate[] = this.data.user.steps || [];
  imgUserDefault: string;
  imgUpload: File;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<UserUpdateComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private roleService: RoleService,
    private cryptoPassword: CryptoPasswordService,
    private usersService: UsersService,
    private dataService: DataService,
    private stepsService: StepsService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.isActive = this.data.user.isActive;
    this.isActiveValue = this.data.user.isActive;
    this.getUserPhoto();
    this.getSteps();
    this.getRoles();
    this.initForm();
  }

  isInactive(valueInput: string): void {
    let inputValue = true;

    const existInValueForm = this.valueForm.find(item => item === valueInput.toString());
    const regex = /^-?(0|[1-9]\d*)?$/;

    existInValueForm ?
      inputValue = false :
      valueInput ? inputValue = true : inputValue = false;

    inputValue ? this.inactive = false : this.inactive = true;
  }

  onSubmit(): void {
    const roleUser = this.roles.find(item => item.name === this.updateUserForm.get('role').value);
    const valuePassword = this.updateUserForm.get('password').value;
    const passwordSha256 = valuePassword ? this.authService.cryptString(valuePassword) : null;

    if (this.updateUserForm.get('role').value === 'admin') {
      this.stepsForUser = null;
    }

    const updateUser: UserUpdate = {
      username: this.updateUserForm.get('username').value,
      firstname: this.updateUserForm.get('firstname').value,
      lastname: this.updateUserForm.get('lastname').value,
      role: roleUser,
      id: this.data.user.id,
      steps: this.stepsForUser,
      password: passwordSha256,
    };


    this.usersService.updateUser(updateUser).subscribe(res => {
      this.confirmUpdateUser = true;
      if (this.imgUpload !== undefined) {
        this.usersService.updatePhotoUser(res.id, this.imgUpload).subscribe(() => { });
      }
      this.getUser(this.updateUserForm.get('username').value);

    });

  }

  userIsActiveOrNot(): void {
    this.isActiveValue === true ?
      this.usersService.desactivateUser(this.data.user.id).subscribe(() => { this.isActiveValue = !this.isActiveValue; }) :
      this.usersService.activateUser(this.data.user.id).subscribe(() => { this.isActiveValue = !this.isActiveValue; });
    this.usersService.getUser().subscribe(res => {
      this.dataService.usersList$.next(res);
    });

    this.inactive = !this.inactive;

    if (this.isActiveValue) {
      this.dialogRef.close();
    }
  }

  addOrRemoveStep(step: Step): void {
    const convertStep: StepUpdate = {
      name: step.name,
      id: step.id
    };

    const indexStep = this.stepsForUser.findIndex(item => item.id === step.id);

    this.inactive = false;

    indexStep === -1 ?
      this.stepsForUser.push(convertStep) :
      this.stepsForUser.splice(indexStep, 1);
  }

  isChecked(step: Step): boolean {
    const stepExist = this.stepsForUser.findIndex(item => item.id === step.id);

    return stepExist !== -1 ? true : false;
  }

  convertImage(event): void {
    this.imgUpload = event.target.files[0];
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (res) => {
      this.imgUserDefault = res.target.result.toString();
    };
  }

  private getSteps(): void {
    this.steps = [];
    this.stepsService.getSteps().subscribe(res => {
      res.forEach(item => {
        const stepExist = this.stepsForUser.findIndex(el => el.id === item.id);
        const stepObj = {
          name: item.name,
          id: item.id,
          stepValid: stepExist !== -1 ? true : false
        };

        this.steps.push(stepObj);

      });

      // const form = document.getElementsByClassName('origin_step_category_inputs') as HTMLCollectionOf<HTMLElement>;

    });
  }

  private getRoles(): void {
    this.roleService.getRoles().subscribe(res => this.roles = res);
  }

  private getUser(username: string): void {
    this.usersService.getUser().subscribe(res => {
      const user = res.find(item => item.username === username);
      setTimeout(() => {
        this.dialogRef.close(user);
      }, 3000);
    });
  }

  private getUserPhoto(): void {

    if (this.data.user.hasPhoto) {

      this.usersService.getPhotoUser(this.data.user.id).subscribe(img => {
        reader.readAsDataURL(img);
        reader.onload = (res) => {
          this.imgUserDefault = res.target.result.toString();
        };
      });
    } else {
      this.imgUserDefault = 'https://ionicframework.com/docs/demos/api/avatar/avatar.svg';
    }
  }

  private initForm(): void {
    this.updateUserForm = this.formBuilder.group({
      username: [this.data.user.username, Validators.required],
      firstname: [this.data.user.firstname, Validators.required],
      lastname: [this.data.user.lastname, Validators.required],
      role: [this.data.user.role.name, Validators.required],
      password: [''],
      imgUser: []
    });

    this.valueForm.push(this.data.user.username, this.data.user.role.name);
  }

}
